/*
 * Copyright (c) Nexign, JSC, 2019.
 */
/**
 *
 * @author Maxim Fedorov
 * @version 1.1.0
 * @since 1.1.0
 */

import {
    EExpensesAnalyzerField,
} from '../../../../../pages/PageExpensesAnalyzer/components/ExpensesAnalyzerTable/types/expensesAnalyzerTableTypes';
import { EChartDataKeyEnum, IChartDataInput, IChartErrorConfiguration } from '../../chartTypes';

export const ChartCategoryErrorLegendItems: IChartDataInput[] = [
    {
        [EChartDataKeyEnum.checked]: true,
        [EChartDataKeyEnum.order]: 6,
        [EChartDataKeyEnum.total]: 0,
        [EChartDataKeyEnum.x]: EExpensesAnalyzerField.AMOUNT_COUNTRY_ROAMING,
        [EChartDataKeyEnum.y]: {},
    },
    {
        [EChartDataKeyEnum.checked]: true,
        [EChartDataKeyEnum.order]: 5,
        [EChartDataKeyEnum.total]: 0,
        [EChartDataKeyEnum.x]: EExpensesAnalyzerField.AMOUNT_LOCAL_MACRO,
        [EChartDataKeyEnum.y]: {},
    },
    {
        [EChartDataKeyEnum.checked]: true,
        [EChartDataKeyEnum.order]: 4,
        [EChartDataKeyEnum.total]: 0,
        [EChartDataKeyEnum.x]: EExpensesAnalyzerField.AMOUNT_ROAMING,
        [EChartDataKeyEnum.y]: {},
    },
    {
        [EChartDataKeyEnum.checked]: true,
        [EChartDataKeyEnum.order]: 3,
        [EChartDataKeyEnum.total]: 0,
        [EChartDataKeyEnum.x]: EExpensesAnalyzerField.AMOUNT_LOCAL,
        [EChartDataKeyEnum.y]: {},
    },
    {
        [EChartDataKeyEnum.checked]: true,
        [EChartDataKeyEnum.order]: 2,
        [EChartDataKeyEnum.total]: 0,
        [EChartDataKeyEnum.x]: EExpensesAnalyzerField.CHARGES,
        [EChartDataKeyEnum.y]: {},
    },
    {
        [EChartDataKeyEnum.checked]: true,
        [EChartDataKeyEnum.order]: 1,
        [EChartDataKeyEnum.total]: 0,
        [EChartDataKeyEnum.x]: EExpensesAnalyzerField.MONTH_CHARGE_SRLS,
        [EChartDataKeyEnum.y]: {},
    },
    {
        [EChartDataKeyEnum.checked]: true,
        [EChartDataKeyEnum.order]: 0,
        [EChartDataKeyEnum.total]: 0,
        [EChartDataKeyEnum.x]: EExpensesAnalyzerField.MONTH_CHARGE_RTPL,
        [EChartDataKeyEnum.y]: {},
    },
];

export const ChartCategoryErrorConfiguration: IChartErrorConfiguration = {
    legendItems: ChartCategoryErrorLegendItems,
};
